import React from 'react'

/**
 * Reusable Card component with responsive design
 * Adapts layout based on screen size and content
 */
const Card = ({
  children,
  contentClassName = '',
  title,
  subtitle,
  actions,
  variant = 'default',
  className = '',
  padding = 'default',
  shadow = 'default',
  ...props
}) => {
  // Variant classes
  const variantClasses = {
    default: 'bg-white border border-gray-200',
    elevated: 'bg-white shadow-lg border-0',
    outlined: 'bg-white border-2 border-gray-300',
    filled: 'bg-gray-50 border border-gray-200',
  }
  
  // Padding classes
  const paddingClasses = {
    none: 'p-1',
    small: 'p-3',
    default: 'p-4 md:p-6',
    large: 'p-6 md:p-8',
  }
  
  // Shadow classes
  const shadowClasses = {
    none: '',
    small: 'shadow-sm',
    default: 'shadow',
    large: 'shadow-lg',
    xl: 'shadow-xl',
  }
  
  // Base card classes
  const baseClasses = 'rounded-lg transition-all duration-200'
  
  // Combine all classes
  const cardClasses = `${baseClasses} ${variantClasses[variant]} ${paddingClasses[padding]} ${shadowClasses[shadow]} ${className}`

  return (
    <div className={cardClasses} {...props}>
      {/* Header section */}
      {(title || subtitle || actions) && (
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
          <div className="flex-1">
            {title && (
              <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
            )}
            {subtitle && (
              <p className="text-sm text-gray-600 mt-1">{subtitle}</p>
            )}
          </div>
          {actions && (
            <div className="flex-shrink-0 flex flex-wrap gap-2">
              {actions}
            </div>
          )}
        </div>
      )}
      
      {/* Content */}
      <div className={`space-y-4 ${contentClassName}`}>
        {children}
      </div>
    </div>
  )
}

export default Card
